<template>
  <wsp-modal>
    <v-card class="pb-5"
            flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary"
                   dark
                   dense
                   flat>
          <v-toolbar-title>
            {{ $t('global.creditCard.delete.title', { code: card.code }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text v-html="$t('global.creditCard.delete.message')">
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="capitalize primary--text"
               flat
               @click="visible = false">
          {{ $t('global.button.cancel')}}</v-btn>

        <v-btn color="accent"
               class="capitalize white--text mr-2"
               outline
               round
               @click="deleteCreditCard">
          {{ $t('global.button.agree')}}</v-btn>
      </v-card-actions>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import creditCardService from '@/services/creditCardService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'DeleteCreditCard',
  components: {
    [WspModal.name]: WspModal
  },
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    async deleteCreditCard() {
      let params = {
        id: this.card.id
      };
      let results = await creditCardService.delete(params)

      if (results.error) {
        manageErrorService.handle(results.data);
        this.showContent = true
        return;
      }

      this.visible = false
      this.$emit('on-success', {})

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('global.creditCard.delete.toast.successs'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
